// Layout.tsx
import React, { useState, useEffect } from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import api from '../api/axios';
import navBg from '../assets/layout/img1.png';
import silverImg from '../assets/layout/silver.png';
import goldImg from '../assets/layout/gold.png';
import './Layout.css';

type Stats = {
  level: number;
  xp: number;
  xp_to_next: number;
  silver: number;
  gold: number;
};

const links: Array<{ to: string; label: string; emoji: string }> = [
  { to: '/adventure',  label: 'Adventure',   emoji: '🗺️' },
  { to: '/character',  label: 'Character',   emoji: '🧙‍♂️' },
  { to: '/sleep',      label: 'Sleep',       emoji: '😴' },
  { to: '/dungeon',    label: 'Dungeon',     emoji: '🕳️' },
  { to: '/gathering',  label: 'Gathering',   emoji: '🌾' },
  { to: '/processing', label: 'Processing',  emoji: '⚗️' },
  { to: '/shop',       label: 'Shop',        emoji: '🏪' },
  { to: '/crafting',   label: 'Crafting',    emoji: '🛠️' },
  { to: '/treasury',   label: 'Treasury',    emoji: '💰' },
  { to: '/staking',   label: 'Staking',    emoji: '💰' },
  { to: '/stable',     label: 'Stable',      emoji: '🐴' },
  { to: '/tavern',     label: 'Tavern',      emoji: '🍻' },
  { to: '/leaderboard',label: 'Leaderboard', emoji: '🏆' },
  { to: '/settings',   label: 'Settings',    emoji: '⚙️' },
  //  { to: '/duel',       label: 'Duel',        emoji: '⚔️' },
  //  { to: '/raid',       label: 'Raid',        emoji: '🛡️' },
  { to: '/login',      label: 'Log out',     emoji: '' },
];

export const Layout: React.FC = () => {
  const [stats, setStats] = useState<Stats | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let isMounted = true;
    const fetchStats = () => {
      api.get<Stats>('/character')
        .then(res => {
          if (isMounted) setStats(res.data);
        })
        .catch(err => {
          if (isMounted) {
            setError(err.response?.data?.error || err.message);
            console.error(err);
          }
        });
    };

    fetchStats();
    const interval = setInterval(fetchStats, 30000);
    return () => {
      isMounted = false;
      clearInterval(interval);
    };
  }, []);

  if (error) return <p className="error">{error}</p>;
  if (!stats) return <div className="app-shell">Loading…</div>;

  const xpPercent = Math.floor((stats.xp / stats.xp_to_next) * 100);

  return (
    <div className="app-shell">
      <aside className="sidebar">
        <header className="sidebar-header">
          <div className="level">
            Lv. {stats.level} <small>({stats.xp} / {stats.xp_to_next} XP)</small>
          </div>
          <div className="currency">
            <span><img src={silverImg} alt="Silver" className="coin" /> {stats.silver.toLocaleString()}</span>
            <span><img src={goldImg} alt="Gold" className="coin" /> {stats.gold}</span>
          </div>
          <div className="xp-bar">
            <div
              className="xp-bar-fill"
              style={{ width: `${xpPercent}%` }}
              title={`${xpPercent}% to next level`}
            />
          </div>
        </header>

        <nav className="sidebar-nav">
          {links.map(({ to, label, emoji }) => (
            <NavLink
              key={to}
              to={to}
              className={({ isActive }) => `nav-link${isActive ? ' active' : ''}`}
              style={{ backgroundImage: `url(${navBg})` }}
            >
              <span className="icon">{emoji}</span>
              <span className="text">{label}</span>
            </NavLink>
          ))}
        </nav>
      </aside>

      <main className="main-content">
        <Outlet />
      </main>
    </div>
  );
};